import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppContext} from "../../definitions/types";

const viewModel = window.viewModel;

export const name = "app";

const appSlice = createSlice({
    name: name,
    initialState: {
        value: {
            breadCrumbs: viewModel.breadCrumbItems,
            catalogId: viewModel.catalogId,
            currencyCode: viewModel.currencyCode,
            primaryId: viewModel.primaryId,
            productId: viewModel.productId,
            questionCount: viewModel.questionCount,
            ratingAverageGrade: viewModel.ratingAverageGrade ? Math.round(viewModel.ratingAverageGrade * 100) / 100 : undefined,
            ratingCount: viewModel.ratingCount,
            sku: viewModel.sku,
            title: viewModel.title
        }
    },
    reducers: {
        update: (state, action: PayloadAction<Pick<AppContext, 'productId' | 'primaryId'>>) => {
            state.value = {...state.value, ...action.payload};
        }
    }
});

export const {update: updateAppContext} = appSlice.actions;
export default appSlice.reducer;